import { useTheme } from '@mui/material';
import React from 'react';

import { ListItem } from '../../components/ListItem/ListItem';
import { ListItemButton } from '../../components/ListItemButton/ListItemButton';
import { ListItemIconProps, ListItemIcon } from '../../components/ListItemIcon/ListItemIcon';
import { ListItemText } from '../../components/ListItemText/ListItemText';
import { Tooltip } from '../../components/Tooltip/Tooltip';

export type NavigationItemProps = {
  icon: ListItemIconProps['children'];
  isNavExpanded: boolean;
  text: string;
  isActive?: boolean;
  onClick?: () => void;
};

export const NavigationItem = (props: NavigationItemProps) => {
  const { icon, isNavExpanded, text, isActive, onClick } = props;

  const theme = useTheme();

  const activeColor = isActive ? theme.palette.primary.main : undefined;

  return (
    <Tooltip title={!isNavExpanded ? text : ''} placement='right'>
      <div>
        <ListItem disablePadding>
          <ListItemButton
            onClick={onClick}
            sx={{
              minHeight: 48,
              justifyContent: isNavExpanded ? 'initial' : 'center'
            }}>
            <ListItemIcon
              sx={{
                minWidth: 0,
                marginRight: isNavExpanded ? 1 : 0,
                justifyContent: 'center',
                '& .MuiSvgIcon-root': {
                  color: activeColor || 'inherit'
                }
              }}>
              {icon}
            </ListItemIcon>
            <ListItemText
              primary={text}
              sx={{ display: isNavExpanded ? 'block' : 'none' }}
              slotProps={{
                primary: { color: activeColor }
              }}
            />
          </ListItemButton>
        </ListItem>
      </div>
    </Tooltip>
  );
};
